import React, { useContext } from "react";
import { FontSizeContext } from "../../context/FontSizeContext";
import './FontSizeController.css'


export default function FontSizeController() {
  const { increaseFont, decreaseFont, resetFont } = useContext(FontSizeContext);

  return (
   <div style={{ display: "inline-flex", gap: "8px" }}>
      <button 
      className="font-size-btn"
       style={{backgroundColor: "#013c66", color : "#ffff"}}
        type="button" 
        onClick={decreaseFont} 
        aria-label="A- Decrease font size"
      >
        A-
      </button>

      <button 
      className="font-size-btn"
      style={{backgroundColor: "#013c66", color : "#ffff"}}
        type="button" 
        onClick={resetFont} 
        aria-label="A Reset font size"
      >
        A
      </button>

      <button 
      className="font-size-btn"
      style={{backgroundColor: "#013c66", color : "#ffff"}}
        type="button" 
        onClick={increaseFont} 
        aria-label="A+ Increase font size"
      >
        A+
      </button>
    </div>
  );
}
